import script from "./index.vue?vue&type=script&setup=true&lang=js"
export * from "./index.vue?vue&type=script&setup=true&lang=js"

import "./index.vue?vue&type=style&index=0&id=53d4778a&lang=css"
import "./index.vue?vue&type=style&index=1&id=53d4778a&scoped=true&lang=css"

import exportComponent from "/Users/huangzexu/Code/Vue/Yiban/yiban/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-53d4778a"]])

export default __exports__